import React from 'react';
import { Grid, Typography, Button } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CloseIcon from '@mui/icons-material/Close';

const FilterTitle = ({ screenWidth, onClose }) => (
  <Grid
    item
    container
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}
  >
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: '24px',
        color: 'black',
        display: 'flex',
        alignItems: 'center',
        cursor: screenWidth < 1280 ? 'pointer' : 'default',
      }}
    >
      {screenWidth < 1280 && (
        <ArrowBackIosIcon
          onClick={onClose}
          sx={{ mr: 1, fontSize: '20px', cursor: 'pointer' }}
        />
      )}
      Filtros
    </Typography>

    <Button
      onClick={onClose}
      sx={{
        minWidth: 'auto',
        padding: 0,
        ml: 1,
      }}
    >
      <CloseIcon />
    </Button>
  </Grid>
);

export default FilterTitle;
